export default ((store, api, sharedActions) => {
  const setPasswordRotationState = payload => {
    Object.assign(store.auth.passwordRotationState, payload);
  };
  const setStep = step => {
    setPasswordRotationState({
      step
    });
  };
  return {
    setStep
  };
});